export enum BuildGroup {
  App = "app",
  KioskServices = "kioskServices",
  MobileServices = "mobileServices",
  Kiosk = "kiosk",
  Mobile = "mobile",
  Manager = "manager"
}
